<template>
  <div>
    <!-- 面包屑导航 -->
    <el-breadcrumb separator-class="el-icon-arrow-right">
      <el-breadcrumb-item :to="{ path: '/home' }">首页</el-breadcrumb-item>
      <el-breadcrumb-item>内部管理</el-breadcrumb-item>
      <el-breadcrumb-item>人事管理</el-breadcrumb-item>
      <el-breadcrumb-item>薪资社保公积金</el-breadcrumb-item>
    </el-breadcrumb>

    <!-- Tabs -->
    <el-tabs v-model="activeName" type="border-card">
      <!-- 清单列表 strat -->
      <el-tab-pane label="清单列表" name="first">
        <!-- 查询 start -->
        <el-form :inline="true" :model="keywords" ref="keywordsRef" label-width="82px">
          <el-form-item label="单位">
            <RsljigouInternal :propsjigouid="keywords.danweijigouid" :propsjigouname="keywords.danweijigouname" @change="changedanweiRsljigouInternal"></RsljigouInternal>
          </el-form-item>
          <el-form-item label="部门">
            <RsljigouInternal :propsjigouid="keywords.jigouid" :propsjigouname="keywords.jigouname" @change="changeRsljigouInternal"></RsljigouInternal>
          </el-form-item>
          <el-form-item label="">
            <el-date-picker v-model="keywords.beginyears" type="month" placeholder="选择起始年月" class="select" value-format="yyyy-MM"></el-date-picker>
          </el-form-item>
          <el-form-item label="">
            <el-date-picker v-model="keywords.endyears" type="month" placeholder="选择结束年月" class="select" value-format="yyyy-MM"></el-date-picker>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" @click="clicksearch">查询</el-button>
            <el-button type="success" @click="clickmuban" plain>点击下载批量导入模板</el-button>
            <TencentyunCosUploadExcel @change="changeTencentyunCosUploadExcel"></TencentyunCosUploadExcel>
          </el-form-item>
        </el-form>
        <!-- 查询 end -->

        <el-table :data="dataList" :row-class-name="tableRowClassName" border stripe >
          <el-table-column prop="ShangJigouName" label="单位" min-width="8%"></el-table-column>
          <el-table-column prop="CurJigouName" label="部门" min-width="8%"></el-table-column>
          <el-table-column prop="Years" label="年月" min-width="7%"></el-table-column>
          <el-table-column prop="Numberofpeople" label="折合人数" min-width="7%"></el-table-column>
          <el-table-column prop="Salary" label="应发工资" min-width="7%"></el-table-column>
          <el-table-column prop="Personalshebao" label="个人社保" min-width="7%"></el-table-column>
          <el-table-column prop="Personalgongjijin" label="个人公积金" min-width="7%"></el-table-column>
          <el-table-column prop="Companyshebao" label="单位社保" min-width="7%"></el-table-column>
          <el-table-column prop="Companygongjijin" label="单位公积金" min-width="7%"></el-table-column>
          <el-table-column prop="Incometax" label="个税" min-width="7%"></el-table-column>
          <el-table-column prop="Actualsalary" label="实发工资" min-width="7%"></el-table-column>
          <el-table-column prop="Actualshebao" label="实付社保" min-width="7%"></el-table-column>
          <el-table-column prop="Actualgongjijin" label="实付公积金" min-width="7%"></el-table-column>
          <el-table-column prop="Actualtotal" label="人工社保支出合计" min-width="7%"></el-table-column>
          <el-table-column prop="Createtime" label="创建时间" min-width="8%"></el-table-column>
          <el-table-column label="操作" min-width="8%">
            <template v-slot="scope">
              <el-button v-if="scope.row.Id > 0" type="text" size="mini" style="margin-left: 0; margin-right: 5px" @click="clickdelete(scope.row)">删除</el-button>
              <el-button v-if="scope.row.Id > 0" type="text" size="mini" style="margin-left: 0; margin-right: 5px" @click="clickedit(scope.row)">修改</el-button>
            </template>
          </el-table-column>
        </el-table>

        <!-- 分页 -->
        <div class="pages">
          <el-pagination
            @current-change="handleCurrentPageChange"
            :page-size="10"
            layout="total, prev, pager, next, jumper"
            :total="dataListnum"
			:current-page.sync="selectedPageNo">
          </el-pagination>
        </div>
      </el-tab-pane>
      <!-- 清单列表 end -->

      <!-- 添加 start -->
      <el-tab-pane label="添加">
        <el-form :model="addData" ref="addDataRef" label-width="180px">
          <el-form-item label="选择部门"  class="addAdminForm">
            <RsljigouInternal :propsjigouid="addData.jigouid" :propsjigouname="addData.jigouname" @change="changeaddDataRsljigouInternal"></RsljigouInternal>
          </el-form-item>
          <el-form-item label="年月" class="addAdminForm">
            <el-date-picker v-model="addData.years" type="month" placeholder="选择年月" class="select" value-format="yyyy-MM"></el-date-picker>
          </el-form-item>
          <el-form-item label="折合人数" class="addAdminForm">
            <el-input v-model="addData.numberofpeople" placeholder="请输入折合人数"></el-input>
          </el-form-item>
          <el-form-item label="应发工资" class="addAdminForm">
            <el-input v-model="addData.salary" placeholder="请输入应发工资"></el-input>
          </el-form-item>
          <el-form-item label="个人社保" class="addAdminForm">
            <el-input v-model="addData.personalshebao" placeholder="请输入个人社保"></el-input>
          </el-form-item>
          <el-form-item label="个人公积金" class="addAdminForm">
            <el-input v-model="addData.personalgongjijin" placeholder="请输入个人公积金"></el-input>
          </el-form-item>
          <el-form-item label="单位社保" class="addAdminForm">
            <el-input v-model="addData.companyshebao" placeholder="请输入单位社保"></el-input>
          </el-form-item>
          <el-form-item label="单位公积金" class="addAdminForm">
            <el-input v-model="addData.companygongjijin" placeholder="请输入单位公积金"></el-input>
          </el-form-item>
          <el-form-item label="个税" class="addAdminForm">
            <el-input v-model="addData.incometax" placeholder="请输入个税"></el-input>
          </el-form-item>
          <el-form-item label="实发工资" class="addAdminForm">
            <el-input v-model="addData.actualsalary" placeholder="请输入实发工资"></el-input>
          </el-form-item>
          <el-form-item label="实付社保" class="addAdminForm">
            <el-input v-model="addData.actualshebao" placeholder="请输入实付社保"></el-input>
          </el-form-item>
          <el-form-item label="实付公积金" class="addAdminForm">
            <el-input v-model="addData.actualgongjijin" placeholder="请输入实付公积金"></el-input>
          </el-form-item>
          <el-form-item label="人工社保支出合计" class="addAdminForm">
            <el-input v-model="addData.actualtotal" placeholder="请输入人工社保支出合计"></el-input>
          </el-form-item>
          <el-form-item class="mt20">
            <el-button type="primary" @click="clickadd">添加</el-button>
            <el-button type="info" @click="clickreturn">返回</el-button>
          </el-form-item>
        </el-form>
      </el-tab-pane>
      <!-- 添加 end -->

      <el-tab-pane label="修改" name="second" disabled="disabled">
        <PersonpayrollChange ref="SubVuesecond" v-on:triggerFunc="clickreturn"></PersonpayrollChange>
      </el-tab-pane>

    </el-tabs>
    <!-- Tabs end -->
  </div>
</template>

<script>
import RsljigouInternal from '@/components/RsljigouInternal.vue'
import TencentyunCosUploadExcel from '@/components/TencentyunCosUploadExcel.vue'
import PersonpayrollChange from '@/componentsSubVue/PersonpayrollChange.vue'
import Vue from 'vue'
import axios from 'axios'
import VueAxios from 'vue-axios'
import Qs from 'qs'
Vue.use(VueAxios, axios)

export default {
  components: {
    RsljigouInternal,
    TencentyunCosUploadExcel,
    PersonpayrollChange
  },
  name: 'MyWorkprojectbudget',
  data () {
    return {
      activeName: 'first',
      selectedPageNo: 1,
      dataList: [],
      dataListnum: 0,
      // 筛选条件
      keywords: {
        danweijigouid: '0',
        danweijigouname: '',
        jigouid: '0',
        jigouname: '',
        beginyears: '',
        endyears: ''
      },
      // 添加
      addData: {
        jigouid: '0',
        jigouname: '',
        years: '',
        numberofpeople: '',
        salary: '',
        personalshebao: '',
        personalgongjijin: '',
        companyshebao: '',
        companygongjijin: '',
        incometax: '',
        actualsalary: '',
        actualshebao: '',
        actualgongjijin: '',
        actualtotal: ''
      },
      Totalamount: 0
    }
  },
  mounted () {
    this.apiPersonpayrollnum()
    this.apiPersonpayrolllist()
  },
  methods: {
    tableRowClassName ({ row, rowIndex }) {
      if (rowIndex === 0) {
        return 'firstline'
      }
      return ''
    },
    changeTencentyunCosUploadExcel (url) {
      this.apiExcelImportPersonpayroll(url)
    },
    changedanweiRsljigouInternal (vid, vname) {
      this.keywords.danweijigouid = vid
      this.keywords.danweijigouname = vname
    },
    changeRsljigouInternal (vid, vname) {
      this.keywords.jigouid = vid
      this.keywords.jigouname = vname
    },
    changeaddDataRsljigouInternal (vid, vname) {
      this.addData.jigouid = vid
      this.addData.jigouname = vname
    },
    clickreturn () {
      this.activeName = 'first'
      this.apiPersonpayrollnum()
      this.apiPersonpayrolllist()
    },
    clickmuban () {
      window.open('https://erp-1256233047.cos.ap-shanghai.myqcloud.com/muban/%E6%89%B9%E9%87%8F%E5%AF%BC%E5%85%A5%E6%A8%A1%E6%9D%BF%E8%96%AA%E8%B5%84%E7%A4%BE%E4%BF%9D%E5%85%AC%E7%A7%AF%E9%87%91.xlsx')
    },
    handleCurrentPageChange (selectedPageNo) {
      this.apiPersonpayrolllist()
    },
    clicksearch () {
      this.selectedPageNo = 1
      this.apiPersonpayrollnum()
      this.apiPersonpayrolllist()
    },
    clickadd () {
      this.apiAddPersonpayroll()
    },
    clickdelete (row) {
      this.$confirm('是否删除此信息?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.apiDelPersonpayroll(row)
      })
    },
    clickedit (row) {
      this.activeName = 'second'
      this.$refs.SubVuesecond.LoadData(row)
    },
    apiPersonpayrolllist: function () {
      var that = this
      var useriderp = localStorage.getItem('Useriderp')
      var timestamp = Date.parse(new Date()) / 1000
      var data = {
        os: 'erp',
        useriderp: useriderp,
        timestamp: timestamp,
        localfingerprint: Vue.prototype.FunGetLocalFingerprint(),
        pageno: that.selectedPageNo,
        danweijigouid: that.keywords.danweijigouid,
        jigouid: that.keywords.jigouid,
        beginyears: that.keywords.beginyears,
        endyears: that.keywords.endyears
      }
      // 加上签名
      data.sign = Vue.prototype.FunGetSignErp(data)
      axios.post(Vue.prototype.global.Url_Personpayrolllist, Qs.stringify(data))
        .then(function (response) {
          if (response.data.Code === 200) {
            that.dataList = response.data.List
          }
          Vue.prototype.FunCheckApiCodeBackground(response.data)
        })
        .catch(function (error) {
          Vue.prototype.FunLogError(error)
        })
    },
    apiPersonpayrollnum: function () {
      var that = this
      var useriderp = localStorage.getItem('Useriderp')
      var timestamp = Date.parse(new Date()) / 1000
      var data = {
        os: 'erp',
        useriderp: useriderp,
        timestamp: timestamp,
        localfingerprint: Vue.prototype.FunGetLocalFingerprint(),
        danweijigouid: that.keywords.danweijigouid,
        jigouid: that.keywords.jigouid,
        beginyears: that.keywords.beginyears,
        endyears: that.keywords.endyears
      }
      // 加上签名
      data.sign = Vue.prototype.FunGetSignErp(data)
      axios.post(Vue.prototype.global.Url_Personpayrollnum, Qs.stringify(data))
        .then(function (response) {
          if (response.data.Code === 200) {
            that.dataListnum = response.data.Num
          }
          Vue.prototype.FunCheckApiCodeBackground(response.data)
        })
        .catch(function (error) {
          Vue.prototype.FunLogError(error)
        })
    },
    apiAddPersonpayroll: function () {
      var that = this
      var useriderp = localStorage.getItem('Useriderp')
      var timestamp = Date.parse(new Date()) / 1000
      var data = {
        os: 'erp',
        useriderp: useriderp,
        timestamp: timestamp,
        localfingerprint: Vue.prototype.FunGetLocalFingerprint(),
        jigouid: that.addData.jigouid,
        years: that.addData.years,
        numberofpeople: that.addData.numberofpeople,
        salary: that.addData.salary,
        personalshebao: that.addData.personalshebao,
        personalgongjijin: that.addData.personalgongjijin,
        companyshebao: that.addData.companyshebao,
        companygongjijin: that.addData.companygongjijin,
        incometax: that.addData.incometax,
        actualsalary: that.addData.actualsalary,
        actualshebao: that.addData.actualshebao,
        actualgongjijin: that.addData.actualgongjijin,
        actualtotal: that.addData.actualtotal
      }
      // 加上签名
      data.sign = Vue.prototype.FunGetSignErp(data)
      axios.post(Vue.prototype.global.Url_AddPersonpayroll, Qs.stringify(data))
        .then(function (response) {
          Vue.prototype.FunCheckApiCodeWithCallback(response.data, true, function () {
            that.activeName = 'first'

            that.addData.jigouid = '0'
            that.addData.years = ''
            that.addData.numberofpeople = ''
            that.addData.salary = ''
            that.addData.personalshebao = ''
            that.addData.personalgongjijin = ''
            that.addData.companyshebao = ''
            that.addData.companygongjijin = ''
            that.addData.incometax = ''
            that.addData.actualsalary = ''
            that.addData.actualshebao = ''
            that.addData.actualgongjijin = ''
            that.addData.actualtotal = ''

            that.apiPersonpayrollnum()
            that.apiPersonpayrolllist()
          })
        })
        .catch(function (error) {
          Vue.prototype.FunLogError(error)
        })
    },
    apiDelPersonpayroll: function (row) {
      var that = this
      var useriderp = localStorage.getItem('Useriderp')
      var timestamp = Date.parse(new Date()) / 1000
      var data = {
        os: 'erp',
        useriderp: useriderp,
        timestamp: timestamp,
        localfingerprint: Vue.prototype.FunGetLocalFingerprint(),
        personpayrollid: row.Id
      }
      // 加上签名
      data.sign = Vue.prototype.FunGetSignErp(data)
      axios.post(Vue.prototype.global.Url_DelPersonpayroll, Qs.stringify(data))
        .then(function (response) {
          if (response.data.Code === 200) {
            that.apiPersonpayrollnum()
            that.apiPersonpayrolllist()
          }
          Vue.prototype.FunCheckApiCodeBackground(response.data)
        })
        .catch(function (error) {
          Vue.prototype.FunLogError(error)
        })
    },
    apiExcelImportPersonpayroll: function (url) {
      var useriderp = localStorage.getItem('Useriderp')
      var timestamp = Date.parse(new Date()) / 1000
      var data = {
        os: 'erp',
        useriderp: useriderp,
        timestamp: timestamp,
        localfingerprint: Vue.prototype.FunGetLocalFingerprint(),
        fileurl: url
      }
      // 加上签名
      data.sign = Vue.prototype.FunGetSignErp(data)
      axios.post(Vue.prototype.global.Url_ExcelImportPersonpayroll, Qs.stringify(data))
        .then(function (response) {
          Vue.prototype.FunCheckApiCode(response.data)
        })
        .catch(function (error) {
          Vue.prototype.FunLogError(error)
        })
    }
  }
}
</script>

<style lang="less" scoped>

  .item {
    margin-top: 10px;
    margin-right: 40px;
  }

/deep/ .el-button--mini, .el-button--mini.is-round {
    padding: auto 5px;
}
.select{
   width: 202px;
}

.optometry {
    margin-top: 15px;
    padding: 20px;
    background: #FAFAFA;
    border: 1px solid #EBEEF5;

    & ul{
        flex-wrap: wrap;
        margin: 0;
        padding: 0;

        & li{
            width: 35%;
            line-height: 28px;
            color: #606266;
            list-style: none;
        }
    }
}
.mt20{
   margin-top: 20px;
}

.box-cardprimary{
    margin-top: 0px;
    background: #409eff;
    border: none;
    -webkit-box-shadow: 0 2px 16px 0 rgba(0, 0, 0, 0.05), 0 0 0px 0 rgba(0,0,0,0);
    box-shadow: 0 2px 16px 0 rgba(0, 0, 0, 0.05), 0 0 0px 0 rgba(0,0,0,0);
}

.box-cardwarning{
    margin-top: 0px;
    background: #ebb562;
    border: none;
    -webkit-box-shadow: 0 2px 16px 0 rgba(0, 0, 0, 0.05), 0 0 0px 0 rgba(0,0,0,0);
    box-shadow: 0 2px 16px 0 rgba(0, 0, 0, 0.05), 0 0 0px 0 rgba(0,0,0,0);
}

.box-carddanger{
    margin-top: 0px;
    background: #f56c6c;
    border: none;
    -webkit-box-shadow: 0 2px 16px 0 rgba(0, 0, 0, 0.05), 0 0 0px 0 rgba(0,0,0,0);
    box-shadow: 0 2px 16px 0 rgba(0, 0, 0, 0.05), 0 0 0px 0 rgba(0,0,0,0);
}

.userList{
    display: flex;
    align-items: center;
    .user{
        color:#ffffff;
        margin: 0 20px 0 0;
    }
    .number{
        font-size: 30px;
        margin: 0;
        font-weight: bold;
        color:#ffffff;
    }
}
</style>
